import _classCallCheck from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';

var BaseInfoItem = /*#__PURE__*/function (_Vue) {
  _inherits(BaseInfoItem, _Vue);

  var _super = _createSuper(BaseInfoItem);

  function BaseInfoItem() {
    _classCallCheck(this, BaseInfoItem);

    return _super.apply(this, arguments);
  }

  return BaseInfoItem;
}(Vue);

__decorate([Prop({
  required: true
})], BaseInfoItem.prototype, "label", void 0);

__decorate([Prop({
  required: true
})], BaseInfoItem.prototype, "content", void 0);

BaseInfoItem = __decorate([Component], BaseInfoItem);
export default BaseInfoItem;